"use strict";

var $ = require("jquery");
var uuid = require("./uuidMIT");

var REGISTER_WIDGET = require("../html/Registration.html");
var CHANGE_PASSWORD_COMMON = "";

require("../style/general.scss");
require("../style/uim-widget.scss");
var common = require("./common");
var templatesText = require("../json/TemplatesText.json");

var EMAIL_KEYUP_ABLE = true;
var PWD_KEYUP_ABLE = true;
var CF_PWD_KEYUP_ABLE = true;


var OPTIONAL_FIELDS = [{
    selector: ".ie789-only",
    configKey: "showLabels"
},{
    selector: "#logo-container",
    configKey: "showLogo"
},{
    selector: "#submitButton-container",
    configKey: "showSubmitButton"
},{
    selector: "#passwordRequirements-container",
    configKey: "showPasswordRequirements"
}];

UimRegistrationWidget.prototype.alertNoCallbackFunction = function (name) {
    console.log('******************************');
    console.log('Warning! ' + name + ' callback function not defined.');
    console.log('******************************');
};

UimRegistrationWidget.prototype.validateAndSetCallbacks = function(params) {
    var self = this;
    var validateAndSet = function (callbackName) {
        if (params.configuration[callbackName] == null) {
            self.alertNoCallbackFunction(callbackName);
        } else {
            self[callbackName] = params.configuration[callbackName];
        }
    };
    validateAndSet('accountDoesNotExist');
    validateAndSet('accountExistsAndLoginSucceeded');
    validateAndSet('accountExistsAndLoginFailed');
    validateAndSet('accountCreated');
    validateAndSet('ajaxFailure');
};

function UimRegistrationWidget(params) {
    common.validateParams(params);
    this.validateAndSetCallbacks(params);

    this.isOlderIEVersion = navigator.appVersion.indexOf("MSIE 7.0") > -1 || navigator.appVersion.indexOf("MSIE 8.0") > -1
        || navigator.appVersion.indexOf("MSIE 9.0") > -1;

    this.emailPlaceholder = params.configuration.emailPlaceholder;
    this.passwordPlaceholder = params.configuration.passwordPlaceholder;
    this.passwordConfirmationPlaceholder = params.configuration.passwordConfirmationPlaceholder;
    this.apigeeKey = params.configuration.apigeeKey;
    this.showLabels = this.isOlderIEVersion;
    this.showLogo = params.configuration.showLogo;
    this.showSubmitButton = params.configuration.showSubmitButton;
    this.showPasswordRequirements = params.configuration.showPasswordRequirements;
    this.environment = params.configuration.environment;
    this.apiUrl = common.API_ENVIRONMENTS[this.environment] + '/users';
    this.ssoUrl = common.SSO_ENVIRONMENTS[this.environment];
    this.element = params.element;
    this.isExistUser = false;
    this.previous_user = {
        email: "",
        password: ""
    };
}

UimRegistrationWidget.prototype.init = function () {
    var self = this,
        handleBarTemplates = window.morningstar.uim.templates,
        widgetText = templatesText["en"];

    // Set the template text
    CHANGE_PASSWORD_COMMON = handleBarTemplates.CommonSetPassword(widgetText.commonPassword);

    this.clearErrorMessages();
    this.element.append(REGISTER_WIDGET);

    this.element.find("div#uim-uChangePassword-input").append(CHANGE_PASSWORD_COMMON);
    common.showElement(this.element.find("div#showPasswordRequirements"));

    this.emailField = this.element.find("input#uim-uEmail-input");
    var passwordField = this.element.find("input#uim-uPassword-input");
    var confirmPasswordField = this.element.find("input#uim-uPasswordConfirmation-input");
    var submit = this.element.find("input#uim-registration-submit");
    var emailInputErrors = this.element.find("#email-input-errors");
    var inputErrors = this.element.find("#input-errors");
    var confirmPasswordError = this.element.find("#confirm-password-error");
    this.fields = {
        email: this.emailField,
        password: passwordField,
        confirmPassword: confirmPasswordField
    };

    if (this.emailPlaceholder) {
        this.emailField[0].placeholder = this.emailPlaceholder;
    }
    if (this.passwordPlaceholder) {
        passwordField[0].placeholder = this.passwordPlaceholder;
    }
    if (this.passwordConfirmationPlaceholder) {
        confirmPasswordField[0].placeholder = this.passwordConfirmationPlaceholder;
    }

	this.emailField.on("focus", function () {
		var isEmptyEmail = self.fields.email.val().length === 0;
		if(isEmptyEmail){
			PWD_KEYUP_ABLE = true;
			$("div#email-input-area").removeClass("error");
			common.hideElement(emailInputErrors.find(".uim-message.empty-email-input"));
			common.hideElement(emailInputErrors.find(".uim-message.invalid-email-input"));
		}
    });

    this.emailField.on("blur", function () {
		self.validateEmail();
        if(common.validateRequiredField(self.emailField,emailInputErrors,".uim-message.empty-email-input")) {
            //self.validateEmail();
            self.validateUserData({
                email: self.fields.email.val(),
                password: self.fields.password.val(),
                confirmPassword: self.fields.confirmPassword.val()
            });
        } else {
            common.hideElement(emailInputErrors.find(".uim-message.invalid-email-input"));
        }
        self.updateSubmitState();
    });

	 this.emailField.on("keyup", function () {
		if(!EMAIL_KEYUP_ABLE){
			if(common.validateRequiredField(self.emailField,emailInputErrors,".uim-message.empty-email-input")) {
				self.validateEmail();
				self.validateUserData({
					email: self.fields.email.val(),
					password: self.fields.password.val(),
					confirmPassword: self.fields.confirmPassword.val()
				});
			} else {
				common.hideElement(emailInputErrors.find(".uim-message.invalid-email-input"));
			}

			self.validateEmail();
			self.updateSubmitState();
		}

    });

	passwordField.on("focus", function () {
		var isEmptyPWD = self.fields.password.val().length === 0;
		if(isEmptyPWD){
			PWD_KEYUP_ABLE = true;
			$("div#password-input-area").removeClass("error");
			common.hideElement(inputErrors.find(".uim-message.empty-password-input"));
			common.hideElement(inputErrors.find(".uim-message.required"));
			common.hideElement(inputErrors.find(".uim-message.maxlength"));
		}
    });

    passwordField.on("blur", function () {
		PWD_KEYUP_ABLE = common.validatePassword(passwordField, inputErrors, self.fields.email.val());
        if(common.validateRequiredField(passwordField,inputErrors,".uim-message.empty-password-input")) {
            //PWD_KEYUP_ABLE = common.validatePassword(passwordField, inputErrors, self.fields.email.val());
            self.validateUserData({
                email: self.fields.email.val(),
                password: self.fields.password.val(),
                confirmPassword: self.fields.confirmPassword.val()
            });
        }else {
            common.hideElement(inputErrors.find(".uim-message.maxlength"));
            common.hideElement(inputErrors.find(".uim-message.required"));
        }
        self.updateSubmitState();
    });

	passwordField.on("keyup", function () {
		if(!PWD_KEYUP_ABLE){
            var isEmptyPWD = self.fields.password.val().length === 0;
            if(common.validateRequiredField(passwordField,inputErrors,".uim-message.empty-password-input")) {
                PWD_KEYUP_ABLE = common.validatePassword(passwordField, inputErrors, self.fields.email.val());
                self.validateUserData({
                email: self.fields.email.val(),
                password: self.fields.password.val(),
                confirmPassword: self.fields.confirmPassword.val()
                });
            }else if(isEmptyPWD){
				passwordField.parent().removeClass("error");
				common.hideElement(inputErrors.find(".uim-message.empty-password-input"));
				common.hideElement(inputErrors.find(".uim-message.required"));
				common.hideElement(inputErrors.find(".uim-message.maxlength"));
				//this.clearErrorMessages();
				PWD_KEYUP_ABLE = true;
			}else {
                common.hideElement(inputErrors.find(".uim-message.maxlength"));
                common.hideElement(inputErrors.find(".uim-message.required"));
			}
            self.updateSubmitState();
		}

    });

	confirmPasswordField.on("focus", function () {
		var isEmptyCFPWD = self.fields.confirmPassword.val().length === 0;
		if(isEmptyCFPWD){
			CF_PWD_KEYUP_ABLE = true;
			$("div#change-confirm-password-input-area").removeClass("error");
			common.hideElement(confirmPasswordError.find(".uim-message.password-empty-input"));
			common.hideElement(confirmPasswordError.find(".uim-message.password_match"));
		}
    });

    confirmPasswordField.on("blur", function () {
		CF_PWD_KEYUP_ABLE = common.validateConfirmPassword(passwordField, confirmPasswordField, confirmPasswordError);
        if(common.validateRequiredField(confirmPasswordField,confirmPasswordError,".uim-message.password-empty-input")) {
            //CF_PWD_KEYUP_ABLE = common.validateConfirmPassword(passwordField, confirmPasswordField, confirmPasswordError);
            self.validateUserData({
                email: self.fields.email.val(),
                password: self.fields.password.val(),
                confirmPassword: self.fields.confirmPassword.val()
            });
        } else {
            common.hideElement(confirmPasswordError.find(".uim-message.password_match"));
        }
        self.updateSubmitState();
    });

    confirmPasswordField.on("keyup", function () {
		if(!CF_PWD_KEYUP_ABLE){
			var isEmptyCFPWD = self.fields.confirmPassword.val().length === 0;
			if(common.validateRequiredField(confirmPasswordField,confirmPasswordError,".uim-message.password-empty-input")) {
				CF_PWD_KEYUP_ABLE = common.validateConfirmPassword(passwordField, confirmPasswordField, confirmPasswordError);
				self.validateUserData({
					email: self.fields.email.val(),
					password: self.fields.password.val(),
					confirmPassword: self.fields.confirmPassword.val()
				});
			}else if(isEmptyCFPWD){
				confirmPasswordField.parent().removeClass("error");
				common.hideElement(confirmPasswordError.find(".uim-message.password_match"));
				common.hideElement(confirmPasswordError.find(".uim-message.password-empty-input"));
				CF_PWD_KEYUP_ABLE = true;
			}else {
				common.hideElement(confirmPasswordError.find(".uim-message.password_match"));
			}
			self.updateSubmitState();

		}

    });

    submit.on("click enter", function (e) {
        e.preventDefault();
        self.createUser({
            email: self.fields.email.val(),
            password: self.fields.password.val(),
            confirmPassword: self.fields.confirmPassword.val()
        });
    });

    for (var index = 0; index < OPTIONAL_FIELDS.length; index++) {
        var field = OPTIONAL_FIELDS[index];

        var showField = this[field.configKey];

        if (showField === false || showField === undefined) {
            common.hideElement(this.element.find(field.selector));
        }
    }

};

UimRegistrationWidget.prototype.updateSubmitState = function() {
    if(this.allFilled() && !this.checkValidationErrors()) {
        $('#uim-registration-submit').removeAttr('disabled');
    } else {
        $('#uim-registration-submit').attr("disabled", true);
    }
};

UimRegistrationWidget.prototype.allFilled = function(){
    var filled = true;
    var isEmptyEmail = this.fields.email.val().length === 0;
    var isEmptyPassword = this.fields.password.val().length === 0;
    var isEmptyConfirmPassword = this.fields.confirmPassword.val().length === 0;

    if(isEmptyEmail || isEmptyPassword || isEmptyConfirmPassword){
        filled = false;
    }
    return filled;
};

UimRegistrationWidget.prototype.checkValidationErrors = function() {
    var inputErrorsElement = this.element.find("#input-errors");
    var confirmPasswordElement = this.element.find("#confirm-password-error");
    var emailInputErrorsElement = this.element.find("#email-input-errors");
    return (
        common.checkElement(inputErrorsElement.find(".uim-message.required")) ||
        common.checkElement(inputErrorsElement.find(".uim-message.maxlength")) ||
        common.checkElement(inputErrorsElement.find(".uim-message.empty-password-input")) ||
        common.checkElement(emailInputErrorsElement.find(".uim-message.invalid-email-input")) ||
        common.checkElement(emailInputErrorsElement.find(".uim-message.empty-email-input")) ||
        common.checkElement(confirmPasswordElement.find(".uim-message.password_match")));

};
UimRegistrationWidget.prototype.validateRequiredFields = function() {
    var emailInputErrors = this.element.find("#email-input-errors");
    var confirmPasswordField = this.element.find("input#uim-uPasswordConfirmation-input");
    var passwordField = this.element.find("input#uim-uPassword-input");
    var confirmPasswordError = this.element.find("#confirm-password-error");
    var inputErrors = this.element.find("#input-errors");
    common.validateRequiredField(this.emailField,emailInputErrors,".uim-message.empty-email-input");
    common.validateRequiredField(confirmPasswordField,confirmPasswordError,".uim-message.password-empty-input");
    common.validateRequiredField(passwordField,inputErrors,".uim-message.empty-password-input");
};
UimRegistrationWidget.prototype.validateEmail = function() {
    var isValid = this.emailField[0].validity.valid;
    var email = this.element.find("input#uim-uEmail-input");
    var emailInputErrorsElement = this.element.find("#email-input-errors");
    var validEmailLength = email[0].value.length < 75 ;

	var isEmptyEmail = email[0].value.length === 0;
	if (isEmptyEmail) {
        email.parent().removeClass("error");
        common.hideElement(this.element.find(".uim-message.empty-email-input"));
		common.hideElement(this.element.find(".uim-message.invalid-email-input"));
        //this.clearErrorMessages();
		EMAIL_KEYUP_ABLE = true;
    }else if(validEmailLength && isValid){
        email.parent().removeClass("error");
        common.hideElement(emailInputErrorsElement.find(".uim-message.invalid-email-input"));
		EMAIL_KEYUP_ABLE = true;
    } else {
        email.parent().addClass("error");
        common.showElement(emailInputErrorsElement.find(".uim-message.invalid-email-input"));
		EMAIL_KEYUP_ABLE = (validEmailLength && isValid);
    }

    return validEmailLength && isValid;

};

UimRegistrationWidget.prototype.showEmailErrorMessage = function () {
    var email = this.element.find("input#uim-uEmail-input");

    function isValid() {
        var isInternetExplorer = (navigator.appVersion.indexOf("MSIE 7.0") > -1 ) || (navigator.appVersion.indexOf("MSIE 8.0") > -1 ) || (navigator.appVersion.indexOf("MSIE 9.0") > -1);
        var value = email[0].value;
        var isEmptyEmail = value.length === 0;

        if (isEmptyEmail) {
            return true;
        } else if (isInternetExplorer) {
            var regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i;
            // Test with the regex and test for two scenarios that
            // the regex won't catch (double dots or a dot at as the first character).
            return regex.test(value) && value.indexOf(".") != 0 && value.indexOf("..") == -1;
        } else {
            return email[0].validity.valid;
        }
    }

    if (isValid()) {
        email.parent().removeClass("error");
        common.hideElement(this.element.find(".uim-message.email"));
        this.clearErrorMessages();
    } else {
        email.parent().addClass("error");
        common.showElement(this.element.find(".uim-message.email"));
    }
    return isValid();
};

UimRegistrationWidget.prototype.clearErrorMessages = function () {
    var inputErrorsElement = this.element.find("#input-errors");
    var emailInputErrorsElement = this.element.find("#email-input-errors");
    var confirmPasswordElement = this.element.find("#confirm-password-error");

    common.hideElement(inputErrorsElement.find(".uim-message.required"));
    common.hideElement(inputErrorsElement.find(".uim-message.maxlength"));
    common.hideElement(inputErrorsElement.find(".uim-message.empty-password-input"));
    common.hideElement(emailInputErrorsElement.find(".uim-message.invalid-email-input"));
    common.hideElement(emailInputErrorsElement.find(".uim-message.empty-email-input"));
    common.hideElement(confirmPasswordElement.find(".uim-message.password_match"));
};

UimRegistrationWidget.prototype.validateUserData = function(user) {
    var self = this;
    var requestId = uuid();
    if(this.allFilled() && !this.checkValidationErrors()) {
        if (user.email === this.previous_user.email && user.password === this.previous_user.password) {
            // we have already tried to validate this username & password combination, so we skip.
            return;
        }

        if (user.password !== user.confirmPassword) {
            return;
        }

        this.previous_user.email = user.email;
        this.previous_user.password = user.password;

        $.ajax({
            method: "GET",
            url: this.apiUrl + "?email-address=" + user.email,
            headers: {
                ApiKey: this.apigeeKey,
                "X-API-RequestId": requestId
            }
        }).success(function () {
            self.isExistUser = true;
            self.logUserIn(false, requestId);
        }).error(function (xhr, error) {
            if (xhr.status === 404) {
                // 404 not found is normal for user registering for first time
                self.isExistUser = false;
                self.accountDoesNotExist.call(error);
            } else {
                self.ajaxFailure.call(xhr);
            }
        });
    }
};

UimRegistrationWidget.prototype.createUser = function() {
    var self = this;
    if (this.isExistUser) {
        return;
    }
    var requestId = uuid();
    $.ajax({
        method: "POST",
        url: this.apiUrl,
        data: JSON.stringify({
            data : {
                type : "user" ,
                attributes : {
                    username : self.fields.email.val(),
                    password : self.fields.password.val()
                }
            }
        }),
        headers : {
            ApiKey : this.apigeeKey,
            "X-API-RequestId": requestId
        }
    }).success(function() {
        self.logUserIn(true, requestId);
    }).error(function(xhr) {
        if (xhr.status === 409) {
            // It's 409 Conflict, which means user exists, this should not happen,
            // unless the same user is created in another process in the background,
            // or this function is called on an existing user.
            // In either case, we silently do nothing.
        } else {
            self.ajaxFailure.call(xhr);
        }
    });
};

UimRegistrationWidget.prototype.logUserIn = function(creating, requestId) {
    // IE 10 fix
    var objAppVersion = navigator.appVersion;
    var contentType = "application/json";
    if (objAppVersion.indexOf("MSIE 10.0") > -1) {
        contentType = "text/html";
    }

    var self = this;

    $.ajax({
        method: "POST",
        url: this.ssoUrl + "/sso/json/msusers/authenticate",
        xhrFields: {
            withCredentials: true
        },
        data: "",
        headers: {
            "Content-Type": contentType,
            "X-OpenAM-Username": this.fields.email.val(),
            "X-OpenAM-Password": this.fields.password.val(),
            "X-API-RequestId": requestId
        }
    }).success(function(data) {
        if (creating) {
            self.accountCreated.call();
        } else {
            self.accountExistsAndLoginSucceeded.call(data);
        }
    }).error(function (xhr) {
        if(!creating && xhr.status === 401) {
            self.accountExistsAndLoginFailed.call(xhr);
        } else {
            self.ajaxFailure.call(xhr);
        }
    });
};

UimRegistrationWidget.prototype.validateRegistration = function(){
    return this.allFilled() && !this.checkValidationErrors();
};

module.exports = {
    createComponent: function (params) {
        var uimWidget = new UimRegistrationWidget(params);
        uimWidget.init();

        return {
            setProperty: function () {},
            destroy: function () {
                params.element.children().remove();
            },
            createUser: function() {
                uimWidget.createUser();
            },
            validateRegistration : function () {
                return uimWidget.validateRegistration();
            },
            validateRequiredFields: function () {
                uimWidget.validateRequiredFields();
            }
        };
    }
};



//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/js/registration.js
// module id = 35
// module chunks = 0